// extracted by mini-css-extract-plugin
export default {"top":"Payments_top__PaymS","box":"Payments_box__0KE9u","addButton":"Payments_addButton__ESoCl"};